import api from '@constants/endpoints'
import request from '@helpers/request'
import { combine, createEffect, createEvent, createStore } from 'effector'
import { get } from 'lodash'
import createPreloadersStore from './preloaders'
import { ITribes } from '@interfaces/ITribes';
export const reset = createEvent('Thrwe store reset')

export const getList = createEffect({
    name: 'getList',
    async handler(threadId: string) {
        const data = {}
        const response = await request(api.chats.getChat, {
            data,
            urlParams: { chatId: threadId }
        })
        return response
    }
})


const preloaders = createPreloadersStore([getList]);

const chat = createStore([])
    .on(getList.done, (state, { result }) => get(result, ['data', 'body'], []))
    .reset(reset);
const threads = combine({ chat, preloaders })
export default threads